import { iHouseState } from "../context/interfaces";

interface iSubFocus {
  selectedClue: string,
  orientation: "horizontal" | "vertical",
  focusedHouse: { row: number, column: number },
  houseStates: iHouseState[][],
}


export default function setSubFocus({
  selectedClue= "",
  orientation= "horizontal",
  focusedHouse= { column: 0, row: 0 },
  houseStates} : iSubFocus
  ):{ houseStates: iHouseState[][], focusedHouse: { column: number, row: number }} {
  //We need to set the subFocus to the selectedClue in the houseState
  houseStates.map((row, rowIndex) => {
    row.map((house, houseIndex) => {
      if(orientation === "horizontal"){
      if (house.palavraHorizontal.toString() === selectedClue) {
        house.isSubFocused = true;
        house.isFocused = false;

      } else {
        house.isSubFocused = false;
        house.isFocused = false;

      }
    } else {
      if (house.palavraVertical.toString() === selectedClue) {
        house.isSubFocused = true;
        house.isFocused = false;

      } else {
        house.isSubFocused = false;
        house.isFocused = false;
      }
    }
    if(focusedHouse.column === houseIndex && focusedHouse.row === rowIndex) {
      house.isFocused = true;
    }
    })
  })
  return {houseStates, focusedHouse};
}
